import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-menu-list-filters',
	templateUrl: './menu-list-filters.component.html',
	styleUrls: ['./menu-list-filters.component.scss'],
})
export class MenuListFiltersComponent implements OnInit {
	public addedFilters: string[] = [];
	public isOpenFilters = false;
	@Input() set addedFiltersValue(value: string[]) {
		this.addedFilters = value ?? [];
		console.log('HERE', this.addedFilters);
	}
	@Output() selectedFilters = new EventEmitter<string[]>();
	public listFilters = [
		{
			value: 'meat',
			name: 'features.meat',
		},
		{
			value: 'fish',
			name: 'features.fish',
		},
		{
			value: 'gluten',
			name: 'features.gluten',
		},
		{
			value: 'lactose',
			name: 'features.lactose',
		},
		{
			value: 'peanut',
			name: 'features.peanut',
		},
	];
	constructor(public translate: TranslateService) {}

	ngOnInit() {}
	selectFilters() {
		this.selectedFilters.emit(this.addedFilters);
	}
	changeVariable(event: any, value: string) {
		if (event?.detail?.checked) {
			this.addedFilters.push(value);
		} else {
			this.addedFilters = this.addedFilters.filter(it => it != value);
		}
		this.selectedFilters.emit(this.addedFilters);
	}
}
